2<template>
  <div v-if="store.currentEvent" class="events">
    <div class="event-text">{{ store.currentEvent }}</div>
  </div>
</template>

<script setup lang="ts">
import { useGameStore } from '@/stores/gameStore';

const store = useGameStore();
</script>

<style scoped>
.events {
  background: rgba(255, 170, 0, 0.1);
  border: 1px solid #ffaa00;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 20px;
  text-align: center;
  display: none;
}

.events:not(:empty) {
  display: block;
}

.event-text {
  color: #ffaa00;
  font-weight: bold;
}
</style>